import { Colors } from '@oy/uicore';
import { Button, Checkbox, Text } from '@oy/uidesktop';
import { useContext, useEffect, useState } from 'react';
import { useTranslate } from 'src/hooks';
import { SignLegalDocumentModalContext } from '../../useSignLegalDocumentModalContext';
import styles from './SignLegalDocumentFooter.module.css';

export const SignLegalDocumentFooter = () => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const { getTranslation } = useTranslate();

  const {
    allDocument,
    payloadToSignDocuments,
    selectedDocument,
    isBottom,
    onAddSignedDocument,
    onSubmit,
    resetPosition,
  } = useContext(SignLegalDocumentModalContext);

  const isDocumentAlreadySigned =
    selectedDocument && payloadToSignDocuments.includes(selectedDocument);

  useEffect(() => {
    setIsChecked(false);
  }, [selectedDocument]);

  const handleMouseEnter = () => {
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };

  const onClickAgree = () => {
    if (!isBottom) {
      setTooltipVisible(true);
      return;
    }

    if (isBottom && !isChecked) {
      setIsError(true);
      return;
    }
    setIsChecked(false);
    resetPosition();
    if (selectedDocument) {
      setTimeout(() => {
        onAddSignedDocument(selectedDocument);
      }, 100);
    }
  };

  const isDisable = allDocument.length !== payloadToSignDocuments.length;

  if (!selectedDocument) {
    return (
      <div className={styles.container}>
        <div className={styles.bottomSectionPreviewDocument}>
          <Button
            disabled={isDisable}
            className={styles.buttonContainer}
            onClick={onSubmit}
          >
            {getTranslation('common_submit')}
          </Button>
        </div>
      </div>
    );
  }

  if (isDocumentAlreadySigned) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div
        className={styles.bottomSectionPreviewDocument}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div>
          <Checkbox
            type="box"
            title={getTranslation('tickbox_pks_serviceAgreement')}
            checked={isChecked}
            onChange={() => {
              if (!isBottom) return;
              setIsChecked(prev => !prev);
              setIsError(false);
            }}
            disabled={!isBottom}
            customDescription={
              isError ? (
                <Text
                  textStyle={Text.Style.BodySmRegular}
                  color={Colors.RED100}
                >
                  {getTranslation('kyb_vidaAgreement_errorMessage_mustAgree')}
                </Text>
              ) : null
            }
          />
        </div>

        {!isBottom && isTooltipVisible && (
          <div className={styles.customTooltip}>
            <Text textStyle={Text.Style.BodySmRegular} color={Colors.WHITE}>
              {getTranslation('kyb_vidaAgreement_scrollInfo')}
            </Text>
          </div>
        )}

        <Button onClick={onClickAgree}>
          {getTranslation('common_approve')}
        </Button>
      </div>
    </div>
  );
};
